<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 12:42:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:56:00
 * @name: 系列表格
 * @Description: 系列表格
 * @FilePath: \preSaleNafterSaleBackstage\src\components\modelGoodsManage\table-series.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <layout v-show="step === 2" :step="step">
      <template v-slot:head>
        <el-button size="mini" plain @click="seriesAdd">添加系列</el-button>
        <el-button size="mini" plain @click="backBrand">返回品牌</el-button>
      </template>
      <template v-slot:bar>
        <font>当前品牌: {{ modelGoods.table_series_data.category_name }}</font>
      </template>
      <template v-slot:table>
        <el-table
          :data="modelGoods.table_series_data.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column align="center" prop="id" label="ID">
          </el-table-column>
          <el-table-column align="center" prop="level_name" label="级别">
          </el-table-column>
          <el-table-column align="center" prop="category_name" label="名称">
          </el-table-column>
          <el-table-column align="center" label="查看型号">
            <template slot-scope="scope">
              <el-button type="text" @click="seriesNext(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="statistics_count"
            label="型号数量"
          >
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                :value="scope.row.status"
                @change="seriesStatusChange($event, scope.row.id)"
                active-color="#13ce66"
                :inactive-color="$scssVars['Vars-font-placeholder-color']"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="seriesEdit(scope.row)"
                >编辑</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="seriesDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          v-if="pagination.page"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="Number(modelGoods.table_series_data.total)"
        ></Pagination>
      </template>
    </layout>
    <addNedit-series
      ref="addNeditSeries"
      :modelGoods="modelGoods"
      @add="seriesAddHandler"
      @edit="seriesEditHandler"
    ></addNedit-series>
  </div>
</template>
<script>
import layout from "@/components/modelGoodsManage/layout.vue";
import addNeditSeries from "./dialog/addNedit-series.vue";
import { confirmation,debounceation } from "@/utils/decorator";

export default {
  name: "modelGoodsManage-tableSeries",
  components: {
    layout,
    addNeditSeries,
  },
  props: {
    step: {
      type: Number,
    },
    modelGoods: {
      type: Object,
    },
  },
  data() {
    // methods -> initData内初始化
    return {
      loading: false, //表格加载状态
      pagination: {}, //品牌表格分页信息
    };
  },
  watch: {
    // 分页器发生变化,更新表格
    pagination: {
      handler(nv, ov) {
        ov.page && this.getTableData();
      },
      immediate: false,
      deep: true,
    },
    // 监听当前品牌id, 当前品牌id变化且有值,获取该品牌下级系列表格数据
    "modelGoods.table_series_data.id": {
      handler(nv, ov) {
        if (nv) {
          this.initData();
          this.getTableData();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 刷新组件
     */
    refresh() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.modelGoods.table_series_data.total = 0;
      this.modelGoods.table_series_data.list = [];
      this.pagination = {
        //品牌表格分页信息
        page: 1, //当前页码
        limit: 10, //每页数据量
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取系列表格数据
     */
    getTableData() {
      this.loading = true;
      let parent_id = this.modelGoods.table_series_data.id;
      let params = { parent_id, ...this.pagination };
      this.modelGoods.getTableSeriesData(params).finally(() => {
        this.loading = false;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 返回品牌表格
     */
    backBrand() {
      this.$emit("update:step", 1);
      this.modelGoods.table_series_data.id = "";
      this.modelGoods.table_series_data.category_name = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 变化系列表格中系列的状态
     * @param {Boolean} e 变化值
     * @param {Number | String} id 系列id
     */
    @debounceation(300)
    seriesStatusChange(e, id) {
      this.modelGoods.seriesStatusChange({
        category_id: id,
        status: e,
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看型号
     * @param {Object} row 系列表格行数据
     */
    @debounceation(300)
    seriesNext(row) {
      this.$emit("update:step", 3);
      this.modelGoods.table_model_data.id = row.id;
      this.modelGoods.table_model_data.category_name = row.category_name;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加系列
     */
    @debounceation(300)
    seriesAdd() {
      this.$refs.addNeditSeries.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 添加系列弹窗回传
     * @param {Object} form 回传数据
     */
    seriesAddHandler(form) {
      this.modelGoods.addSeries(form).then((res) => {
        this.getNewTableData();
        this.$refs.addNeditSeries.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑系列
     * @param {Object} row 系列表格行数据
     */
    @debounceation(300)
    seriesEdit(row) {
      this.$refs.addNeditSeries.open(row);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 编辑系列弹窗回传
     * @param {Object} form 回传数据
     */
    seriesEditHandler(form) {
      this.modelGoods.editSeries(form).then((res) => {
        this.getNewTableData();
        this.$refs.addNeditSeries.cancel();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除系列
     * @param {Object} row 系列表格行数据
     */
    @confirmation((row) => `确认删除系列名为${row.category_name}的系列?`)
    seriesDel(row) {
      this.modelGoods.delSeries({ category_id: row.id }).then((res) => {
        this.getNewTableData();
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 操作后更新表格数据
     */
    getNewTableData() {
      this.getTableData();
      this.$emit("getNewTableData", "tableBrand"); //更新品牌表数据
    },
  },
};
</script>
<style lang="scss" scoped>
.el-table {
  .el-button {
    margin: 0;
    padding: 0 6px;
  }
  .clip {
    color: $Vars-font-placeholder-color;
  }
  /deep/ .el-switch__core:before {
    content: "隐";
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 21px;
  }
  /deep/.is-checked .el-switch__core:before {
    content: "显" !important;
    color: white;
    font-size: $Vars-font-secondary-size;
    line-height: $Vars-font-secondary-size;
    position: absolute;
    top: 3px;
    left: 5px;
  }
}
</style>